import { render } from "./Paging.vue?vue&type=template&id=60f2d3e1&scoped=true"
import script from "./Paging.vue?vue&type=script&lang=js"
export * from "./Paging.vue?vue&type=script&lang=js"

import "./Paging.vue?vue&type=style&index=0&id=60f2d3e1&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f2d3e1"]])

export default __exports__